import { extraccionSimple } from "./dbhelper"

export const obtenerRoles = (params) => {
    return extraccionSimple("roles");
}
